//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "LegacyBlogPost",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
